import en from "@/localization/en.json";

export const questions = [
  {
    id: 1,
    question: en["faq.question_how_amarpet_work"],
    answer: en["faq.answer_how_amarpet_work"],
  },
  {
    id: 2,
    question: en["faq.question_need_to_sign_up"],
    answer: en["faq.answer_need_to_sign_up"],
  },
  {
    id: 5,
    question: en["faq.question_debit_cards_safe"],
    answer: en["faq.answer_debit_cards_safe"],
  },
  {
    id: 6,
    question: en["faq.question_don't_have_debit_card"],
    answer: en["faq.answer_don't_have_debit_card"],
  },
  {
    id: 7,
    question: en["faq.question_hidden_costs"],
    answer: en["faq.answer_hidden_costs"],
  },
  {
    id: 8,
    question: en["faq.question_outside_dhaka"],
    answer: en["faq.answer_outside_dhaka"],
  },
];

export const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "How does AmarPet work?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "You can browse through the website and add products to your cart. Once you have added all your desired products to the cart, you can proceed to checkout. To confirm your order, provide your name, address, and phone number. Select a mode of payment. You can pay online or choose the cash on delivery method. Hit the Place Order button, and your order will be placed.",
      },
    },
    {
      "@type": "Question",
      name: "Do I need to sign up before buying any product?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Yes. In order to place an order, you are required to register on our site. The registration process is very simple. You just need to provide some basic information, such as your name, email address, and contact number. That’s it! Your account will be created. You need to add a delivery address when you order any product.",
      },
    },

    {
      "@type": "Question",
      name: "Is using credit/debit cards safe on AmarPet.com?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Yes. We do not store any card data. The payment is done by Bank approved payment gateways only.",
      },
    },

    {
      "@type": "Question",
      name: "I don't have a credit/debit card. Can I purchase from AmarPet?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Yes, sure, you can. You can use mobile banking services such as bKash or Nagad. You can even choose a cash-on-delivery method to pay for the products in cash when you receive them.",
      },
    },

    {
      "@type": "Question",
      name: "Are there any hidden costs apart from the product price and delivery charges?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "No. You will only pay for the product and the delivery charge. The delivery charge will be applied according to your location & product weight.",
      },
    },

    {
      "@type": "Question",
      name: "Does AmarPet deliver outside Dhaka?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Yes. We provide home delivery throughout Bangladesh.",
      },
    },

    {
      "@type": "Question",
      name: "I forgot my password. What can I do now?",
      acceptedAnswer: {
        "@type": "Answer",
        text: `If you have forgotten your password,
        Visit www.amarpet.com
        Click on the ‘sign in’ button.
        You will be redirected to a page where there will be a ‘Forgot my password’ option. Click on that button. You will be redirected to a new page.
        You will be required to fill up a field mentioning your email address which was used during the registration at AmarPet.
        You will receive a new password in your email inbox.
        Sign in using the new password.`,
      },
    },

    {
      "@type": "Question",
      name: "What are the payment options at AmarPet.com?",
      acceptedAnswer: {
        "@type": "Answer",
        text: `We offer various payment options according to our customers’ convenience. To purchase online, you can use:
        debit card/credit card - Visa, Mastercard, American Express, Nexus card
        mobile payment - bKash, Nagad
        Cash on delivery - pay in cash when you receive the product`,
      },
    },

    {
      "@type": "Question",
      name: "I have a few questions and want some assistance. Who do I contact?",
      acceptedAnswer: {
        "@type": "Answer",
        text: `You can call us at +8801322908241 or inbox us on our Facebook page`,
      },
    },

    {
      "@type": "Question",
      name: "What can I do if I enter an incorrect shipping address?",
      acceptedAnswer: {
        "@type": "Answer",
        text: `You have to contact us to update your shipping information. You can call us at +8801322908241 or inbox us on our Facebook page`,
      },
    },
  ],
};
